export default __webpack_public_path__ + "static/1437-bbe85d4c16dabf0cc924a50ee6a09196.gif";